export default __webpack_public_path__ + "static/media/taover1.96f18a95.png";